module.exports = __webpack_public_path__ + "img/austellung_rathaus.f64ad777.jpg";